import * as Blockly from 'blockly/core'
import { LuaGenerator, Order } from 'blockly/lua'
import {
  BlockDefinition,
  indent,
  makeMissionObjectField,
  messageField,
  numberInput,
  statementBlock,
  substackInput,
} from './common'

export const eventDefaults: Partial<BlockDefinition> = {
  style: 'events',
}

export const eventBlocks: Array<BlockDefinition> = [
  {
    opcode: 'events_setHealthTo',
    ...statementBlock,
    ...numberInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const v = generator.valueToCode(block, 'VAL', Order.RELATIONAL)
      return `humanoid.Health = ${v}\n`
    },
    message0: '%{BKY_B_SET_HEALTH_TO}',
  },
  {
    opcode: 'events_setJumpPowerTo',
    ...statementBlock,
    ...numberInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const v = generator.valueToCode(block, 'VAL', Order.RELATIONAL)
      return `humanoid.JumpPower = ${v}\n`
    },
    message0: '%{BKY_B_SET_JUMP_POWER_TO}',
  },
  {
    opcode: 'events_setWalkSpeedTo',
    ...statementBlock,
    args0: [
      {
        type: 'field_number',
        name: 'VAL',
        value: 16,
        check: 'Number',
        max: 100,
      },
    ],
    generator: (block: Blockly.Block) => {
      const v = block.getFieldValue('VAL')
      return `humanoid.WalkSpeed = ${v}\n`
    },
    message0: '%{BKY_B_SET_WALK_SPEED_TO}',
  },
  {
    opcode: 'events_onPlay',
    ...substackInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const substack = indent(generator.statementToCode(block, 'SUBSTACK'))
      return `do
  local event = Instance.new("BindableEvent")

  function onPlay()
${substack}  end

  event.Event:Once(onPlay)
  event:Fire()
end\n`
    },
    message0: '%{BKY_B_ON_PLAY}',
    message1: '%1',
  },
  {
    opcode: 'events_onMessage',
    ...messageField,
    ...substackInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const v = block.getFieldValue('VAL')
      const substack = indent(generator.statementToCode(block, 'SUBSTACK'))
      return `do
  local event = game:GetService("ServerStorage"):FindFirstChild("${v}")

  if event == nil then
    event = Instance.new("BindableEvent")
    event.Name = "${v}"
    event.Parent = game:GetService("ServerStorage")
  end

  function onMessage()
${substack}  end

  event.Event:Connect(onMessage)
end\n`
    },
    message0: '%{BKY_B_ON_MESSAGE}',
    message1: '%1',
  },
  {
    opcode: 'events_sendMessage',
    ...statementBlock,
    ...messageField,
    generator: (block: Blockly.Block) => {
      const v = block.getFieldValue('VAL')
      return `do
  local event = game:GetService("ServerStorage"):FindFirstChild("${v}")

  if event == nil then
    event = Instance.new("BindableEvent")
    event.Name = "${v}"
    event.Parent = game:GetService("ServerStorage")
  end

  event:Fire()
end\n`
    },
    message0: '%{BKY_B_SEND_MESSAGE}',
  },
  {
    opcode: 'events_onTouchCharacter',
    ...substackInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const substack = indent(generator.statementToCode(block, 'SUBSTACK'))
      return `function onTouch(hit)
  local humanoid = hit.Parent:FindFirstChild("Humanoid")
  if humanoid then
${substack}  end
end

script.Parent.Touched:Connect(onTouch)\n`
    },
    message0: '%{BKY_B_ON_TOUCH_CHARACTER}',
    message1: '%1',
  },
  {
    opcode: 'events_setClickable',
    ...statementBlock,
    generator:
      () => `if script.Parent:FindFirstChild("ClickDetector") == nil then
  Instance.new("ClickDetector").Parent = script.Parent
end\n`,
    message0: '%{BKY_B_SET_CLICKABLE}',
  },
  {
    opcode: 'events_unsetClickable',
    ...statementBlock,
    generator:
      () => `if script.Parent:FindFirstChild("ClickDetector") ~= nil then
  script.Parent.ClickDetector:Destroy()
end\n`,
    message0: '%{BKY_B_UNSET_CLICKABLE}',
  },
  {
    opcode: 'events_onClicked',
    ...substackInput,
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const substack = indent(generator.statementToCode(block, 'SUBSTACK'), 1)
      return `script.Parent.ChildAdded:Connect(function(hit)
  if hit.Name == "ClickDetector" then
    local function click()
${substack}    end
    script.Parent.ClickDetector.MouseClick:Connect(click)
  end
end)\n`
    },
    message0: '%{BKY_B_ON_CLICKED}',
    message1: '%1',
  },
  {
    opcode: 'events_onTouchObject',
    ...substackInput,
    ...makeMissionObjectField(true),
    generator: (block: Blockly.Block, generator: LuaGenerator) => {
      const v = block.getFieldValue('VAL')
      const substack = indent(generator.statementToCode(block, 'SUBSTACK'))
      return `function onTouch(hit)
  if hit.Name == "${v}" then
${substack}  end
end

script.Parent.Touched:Connect(onTouch)\n`
    },
    message0: '%{BKY_B_ON_TOUCH_OBJECT}',
    message1: '%1',
  },
]
